// helpers/appointment.js
import { db } from "../firebase"; // Adjust path based on your project
import { doc, collection, addDoc, updateDoc, serverTimestamp } from "firebase/firestore";

/** Appointment Statuses:
0 = Scheduled (white)
1 = Show (green)
2 = No-show (red)
3 = Cancelled (black)
4 = Rescheduled (yellow)
*/

// Utility to produce a compact, minute-precision ISO string.
const isoMinute = () => new Date().toISOString().slice(0, 16); // "YYYY-MM-DDTHH:mm"

/**
 * Updates an existing appointment with the provided data.
 * @param {string} appointmentId - The appointment document ID.
 * @param {Object} updates - The fields to update (can include any of the appointment fields).
 */
export const updateAppointment = async (appointmentId, updates) => {
  try {
    const appointmentRef = doc(db, "appointments", appointmentId);

    const base = {
      ...updates,
      updatedAt: serverTimestamp(),
      updatedAtMinute: isoMinute(),
    };

    // If the appointment is being explicitly rescheduled, capture a dedicated timestamp.
    if (updates?.status === 4) {
      base.rescheduledAt = serverTimestamp();
      base.rescheduledAtMinute = isoMinute();
    }

    await updateDoc(appointmentRef, base);
  } catch (error) {
    console.error("Error updating appointment:", error);
    throw error;
  }
};

/**
 * Creates a new appointment in the "appointments" collection.
 * @param {Object} appointmentData - The data for the new appointment (includes client, date, startTime, endTime, location, etc.).
 */
export const createAppointment = async (appointmentData) => {
  try {
    const appointmentsRef = collection(db, "appointments");

    // Default to Scheduled (0) if no status supplied.
    const docRef = await addDoc(appointmentsRef, {
      status: appointmentData.status ?? 0,
      ...appointmentData,
      createdAt: serverTimestamp(),
      createdAtMinute: isoMinute(),
    });

    return docRef.id;
  } catch (error) {
    console.error("Error creating appointment:", error);
    throw error;
  }
};

export const statusToString = (appointmentStatusNumber) => {
  const statusStrings = ["Scheduled", "Show", "No-show", "Cancelled", "Rescheduled"];
  return statusStrings[appointmentStatusNumber];
};

export const statusToStringSpanish = (appointmentStatusNumber) => {
  const statusStrings = ["Programada", "Asistió", "No asistió", "Cancelada", "Reprogramada"];
  return statusStrings[appointmentStatusNumber];
};
